import { Fragment, useEffect, useState } from "react";
import { Button, Container } from 'react-bootstrap';
import { FaArrowRight, FaRegNewspaper, FaVideo } from 'react-icons/fa6';
import { useToast } from '../../../context/ToastContext';
import { useGetAllNewsItemsQuery } from '../../../services/endpoints/website/newsItem';
import { GetQueryParams } from '../../../types/api.type';
import { SFCLocation } from '../../../types/place.types';
import { NewsItem } from '../../../types/website.types';
import '../FranchiseLayout.css';

interface FranchiseProps {
  location: SFCLocation | undefined;
}
const defaultScope = '';

export const InTheNewsSubpage: React.FC<FranchiseProps> = ({ location }) => {
  const { addToast } = useToast();
  const [filters] = useState<GetQueryParams>({
    scope: defaultScope,
    data: { entries: 1000 }
  });
  const { data, error, isLoading } = useGetAllNewsItemsQuery(filters);
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);

  useEffect(() => {
    if (error) {
      addToast('Error while loading data', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);

  useEffect(() => {
    if (data && data.results) {
      setNewsItems(data.results);
    }
  }, [data]);

  return (
    <Container className="text-blue pt-4 pb-5">
      <div className="col-12 d-flex justify-content-center flex-nowrap">
        <div className="franchise-find-classes-btn">
          <Button
              className="text-uppercase bg-orange mb-5 px-5 py-3"
              onClick={() => window.scrollTo(0, 0)}
              href={
  location?.latitude != null && location?.longitude != null
    ? `/sessions?origin=${location.latitude}_${location.longitude}`
    : '/sessions'
}          >
            Find Our Classes
            <FaArrowRight
                className="ms-2"
                size={22}
            />
          </Button>
        </div>
      </div>
      <div>
        {newsItems?.map((news_item, index) => (
          <Fragment key={`news-${news_item.id}`}>
            <div className="div-news-item d-md-block">
              <div className="div-news-details">
                <div className="subheader">{news_item.published_on}</div>
                {news_item.image_file_name != null && (
                  <img
                    className="image-news float-end"
                    src={`${news_item.s3_base_url}/${news_item.image_file_name}`}
                  />
                )}
                <h2>{news_item.name}</h2>
                <div dangerouslySetInnerHTML={{ __html: news_item.details }} />
                <div>
                  {news_item.news_item_links.map((link, link_index) => (
                    <div className="text-fa">
                      <a
                        className="link-block-action w-inline-block text-decoration-none"
                        href={link.target}
                        target="_blank"
                      >
                        {link.link_type == 'article' && (
                          <FaRegNewspaper
                            className="mb-1 me-2"
                            size={16}
                          />
                        )}

                        {link.link_type == 'video' && (
                          <FaVideo
                            className="mb-1 me-2"
                            size={16}
                          />
                        )}

                        {link.text}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="div-break">&nbsp;</div>
          </Fragment>
        ))}
      </div>
    </Container>
  );
};
